import { render, staticRenderFns } from "./MainInfoForm.vue?vue&type=template&id=cba452a2&scoped=true"
import script from "./MainInfoForm.vue?vue&type=script&lang=js"
export * from "./MainInfoForm.vue?vue&type=script&lang=js"
import style0 from "./MainInfoForm.vue?vue&type=style&index=0&id=cba452a2&prod&lang=scss"
import style1 from "./MainInfoForm.vue?vue&type=style&index=1&id=cba452a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba452a2",
  null
  
)

export default component.exports